module.exports = __webpack_public_path__ + "img/login1.96b583ec.jpg";